import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Account',
		url: '/accounts',
		icon: 'address-card-o',
	},
];

class Account extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component="div">
					<Tab label="Account Settings" value="details"/>
					<Tab label="Billing" value="billing"/>
					<Tab label="Customizations" value="customizations"/>
					<Tab label="FFLBoss Cloud" value="cloud"/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Account
						noDelete={false}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						history={this.props.history}
					/>
				</div>
				{this.state.tab === 'billing' &&
				<Objects.AccountBilling
					baseUrl={'/accounts#billing'}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					history={this.props.history}
				/>}
				{this.state.tab === 'customizations' &&
				<Objects.AccountCustomizations
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					history={this.props.history}
				/>}
				{this.state.tab === 'cloud' &&
					// this.props.rootState.locations.filter(
					// 	/** @type {Locations_Object} location **/
					// 	location => !location.archived).map((location) =>
						<Objects.AccountCloud
							key={location.pkey}
							parent={location.pkey}
							parent_binary_id={location.binary_id}
							location={location}
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					// )
				}
				{/*)*/}
			</div>
		);
	}
}


export default Framework.Components.withRootState(Account);
